export default __webpack_public_path__ + "static/media/Flag_of_Guatemala.2cdeda3e.svg";